let moneyFormat = window.theme.moneyFormat;

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(0);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function updatePrice() {
  let ids = [];
  document
    .querySelectorAll('.product-recommend input[type="checkbox"]:checked')
    .forEach(function (elem) {
      ids.push({
        id: elem.value,
        qty: elem.parentNode.querySelector(".qty-input").value,
      });
    });
  let price = 0;
  let comparePrice = 0;
  let products = [];
  ids.forEach(function (i) {
    window.recommendProducts.forEach(function (product) {
      product.variants.forEach(function (item) {
        if (item.id == i.id) {
          products.push({
            price: item.price * i.qty,
            compare_at_price:
              item.compare_at_price > 0 ? item.compare_at_price * i.qty : 0,
          });
        }
      });
    });
  });
  price = products.reduce(function (prev, cur) {
    return prev + cur.price;
  }, 0);

  comparePrice = products.reduce(function (prev, cur) {
    if (cur.compare_at_price > cur.price) {
      return prev + cur.compare_at_price;
    }
    return prev + 0;
  }, 0);

  // 当前产品的价格
  let curProduct = document.querySelector(
    '.pdp-sec .as-product-form input[type="radio"]:checked'
  );
  if (curProduct) {
    let curId = curProduct.getAttribute("data-id");
    let curOption = window.curProduct.variants.find((item) => item.id == curId);
    if (curOption) {
      price += curOption.price;
      if (curOption.compare_at_price > curOption.price) {
        comparePrice += curOption.compare_at_price;
      }
    }
  } else {
    price += window.curProduct.price;
    if (window.curProduct.compare_at_price > window.curProduct.price) {
      comparePrice += window.curProduct.compare_at_price;
    }
  }
  let carBarEl = document.querySelector("#add-to-cart-bar");
  if (carBarEl) {
    carBarEl.querySelector(".as-cur-price").innerHTML = formatMoney(price);
    const compareEl = carBarEl.querySelector(".as-compare-price");
    if (compareEl) {
      if (comparePrice > 0) {
        compareEl.innerHTML = formatMoney(comparePrice);
      } else {
        compareEl.innerHTML = "";
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // 事件委托，只绑定一次
  document.addEventListener("click", function (e) {
    // 加号
    if (e.target.classList.contains("qty-plus")) {
      const selector = e.target.closest(".quantity-selector");
      if (!selector) return;
      const input = selector.querySelector(".qty-input");
      input.value = parseInt(input.value, 10) + 1;
      updateMinusState(selector);
    }
    // 减号
    if (e.target.classList.contains("qty-minus")) {
      const selector = e.target.closest(".quantity-selector");
      if (!selector) return;
      const input = selector.querySelector(".qty-input");
      const min = parseInt(input.getAttribute("min")) || 1;
      let val = parseInt(input.value, 10);
      if (val > min) {
        input.value = val - 1;
        updateMinusState(selector);
      }
    }

    // 更新价格
    updatePrice();
  });

  // 初始化禁用状态
  document.querySelectorAll(".quantity-selector").forEach(function (selector) {
    updateMinusState(selector);
  });

  const productOptionEl = Array.from(
    document.querySelectorAll('.pdp-sec .as-product-form input[type="radio"]')
  );
  const productRecommendEl = Array.from(
    document.querySelectorAll('.product-recommend input[type="checkbox"]')
  );
  const allInputs = [].concat(productOptionEl, productRecommendEl);
  allInputs.forEach(function (el) {
    el.addEventListener("change", function () {
      updatePrice();
    });
  });

  function updateMinusState(selector) {
    const input = selector.querySelector(".qty-input");
    const minus = selector.querySelector(".qty-minus");
    const min = parseInt(input.getAttribute("min")) || 1;
    minus.disabled = parseInt(input.value, 10) <= min;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".as-product-gallery").forEach(function (gallery) {
    const tabList = gallery.querySelector(".main-product-tabs-list");
    if (!tabList) return;
    const tabs = tabList.querySelectorAll(".tab");
    const underline = tabList.querySelector(".tab-underline");
    const tabContents = gallery.querySelectorAll(".main-product-tab-content");

    function updateUnderline() {
      const activeTab = tabList.querySelector(".tab.active");
      if (!activeTab) return;
      underline.style.left = activeTab.offsetLeft + "px";
      underline.style.width = activeTab.offsetWidth + "px";
    }

    // 绑定tab点击
    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
        updateUnderline();

        // 只切换当前gallery下的内容区
        tabContents.forEach(function (content) {
          content.style.display = "none";
        });
        const targetContent = gallery.querySelector(
          '.main-product-tab-content[data-tab="' + tab.dataset.tab + '"]'
        );
        if (targetContent) targetContent.style.display = "block";


        // 停止正在播放
        if (document.querySelector('.product-gallery [data-tab="video"]')) {
          // tab 中的播放器
          var playerItem = document.querySelector('.as-carousel-item-with-video');
          var videoBox = playerItem.querySelector(".as-video-container");
          if (videoBox && videoBox.classList.contains("z-index-1")) {
            videoBox.classList.remove("z-index-1");
            playerItem.player && playerItem.player.stopVideo();
          }
        }
      });
    });

    // 初始化：第一个tab选中，内容区第一个显示
    tabs.forEach((tab, idx) => {
      if (idx === 0) tab.classList.add("active");
      else tab.classList.remove("active");
    });
    tabContents.forEach((content, idx) => {
      content.style.display = idx === 0 ? "block" : "none";
    });

    // 初始化下划线
    updateUnderline();
    window.addEventListener("resize", updateUnderline);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          // class 变化时重新绑定
          updateUnderline();
        }
      });
    });
    observer.observe(gallery, { attributes: true });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".unfold-modal").forEach(function (unfold) {
    unfold.addEventListener("click", function (e) {
      // 找到同一产品卡片下的 .mobile-unfold-trigger
      var parent = unfold.closest(".main-product-tab-content");
      if (parent) {
        var trigger = parent.querySelector(".mobile-unfold-trigger");
        if (trigger) {
          trigger.click();
        }
      }
      // 可选：阻止事件冒泡
      e.stopPropagation();
    });
  });
});

if (window.matchMedia('(min-width: 768px)').matches) {
  let el = $(".detail-left .in-active .main-zoom-image")
  if (!el.length) {
    el = $(".main-zoom-image").eq(0);
  }
  el.ezPlus({
    responsive : true,
    scrollZoom : false,
    showLens: true,
    tint: true,
    tintColour: '#ddd',
    tintOpacity: 0.5,
    borderColour: '#000',
    borderSize: 3,
    zoomWindowHeight: 540,
    zoomWindowWidth: 540,
    respond: [
      {
        range: '769-1199',
        zoomWindowHeight: 320,
        zoomWindowWidth: 320
      },
      {
        range: '100-768',
        enabled: false,
        showLens: false
      }
    ]
  });

  $('.main-product').on('click', '.thumbnail-carousel-item', function() {
    $('.zoomContainer').remove();
    if ($(this).index() == 0) {
      // $(".main-zoom-image").data('ezPlus').refresh();

      $(this).parents('.as-product-gallery').find('.main-zoom-image').eq(0).ezPlus({
        responsive : true,
        scrollZoom : false,
        showLens: true,
        tint: true,
        tintColour: '#ddd',
        tintOpacity: 0.5,
        borderColour: '#000',
        borderSize: 3,
        zoomWindowHeight: 520,
        zoomWindowWidth: 520,
        respond: [
          {
            range: '769-1199',
            zoomWindowHeight: 320,
            zoomWindowWidth: 320
          },
          {
            range: '100-768',
            enabled: false,
            showLens: false
          }
        ]
      });
    }
  })

  $('.select-option .as-step-option').on('change', function() {
     $('.zoomContainer').remove();

     let i = 0
     $('.form-check-input').each(function(index) {
      if ($(this).is(':checked')) {
        i = index;
      }
     })

     $(".main-product .as-product-gallery").eq(i).find('.main-zoom-image').eq(0).ezPlus({
      responsive : true,
      scrollZoom : false,
      showLens: true,
      tint: true,
      tintColour: '#ddd',
      tintOpacity: 0.5,
      borderColour: '#000',
      borderSize: 3,
      zoomWindowHeight: 520,
      zoomWindowWidth: 520,
      respond: [
        {
          range: '769-1199',
          zoomWindowHeight: 320,
          zoomWindowWidth: 320
        },
        {
          range: '100-768',
          enabled: false,
          showLens: false
        }
      ]
    });
  })
}
